import { useRef } from 'react'
import styled from 'styled-components'

const Image = styled.img``

const FallbackImage = ({ fallback, alt, src, ImageComponent = Image, ...rest }) => {
  const called = useRef(false)
  const onError = e => {
    if (called.current) return
    called.current = true
    // eslint-disable-next-line no-param-reassign
    e.target.src = fallback
  }
  return <ImageComponent src={src || fallback} {...rest} alt={alt} onError={onError} />
}

export default FallbackImage
